import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  id?: string;
  inverted?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  id,
  inverted = false
}: SectionHeadingProps) {
  return <div className="max-w-2xl" data-id="element-109" data-mp="3f25ah0bk0cik">
      <div className="flex items-center gap-3" data-id="element-110" data-mp="3f36q7i3iln6m">
        <span className="h-[2px] w-10 bg-gold" aria-hidden="true" data-id="element-111" data-mp="3jzdm0i275iau" />
        <p className={`font-display text-[11px] font-bold uppercase tracking-[0.24em] ${inverted ? 'text-gold-soft' : 'text-navy-steel'}`} data-id="element-112" data-mp="bkdfdd24fcg5">
          {eyebrow}
        </p>
      </div>
      <h2 id={id} className={`mt-5 font-display text-3xl font-extrabold tracking-tight sm:text-4xl ${inverted ? 'text-white' : 'text-navy'}`} data-id="element-113" data-mp="1v3jrn82jbna">
        {title}
      </h2>
    </div>;
}